var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 515,
    height: 509,
    viewBox: "0 0 515 509",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M257.738 0L301.039 75H214.436L257.738 0Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M108.188 48.3892L187.304 83.6137L117.241 134.517L108.188 48.3892Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6432 175.44L100.353 157.434L73.5916 239.798L15.6432 175.44Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4508 332.623L73.3992 268.264L100.161 350.628L15.4508 332.623Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M107.685 459.899L116.737 373.771L186.8 424.675L107.685 459.899Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M257.115 508.654L213.814 433.654L300.417 433.654L257.115 508.654Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M406.664 460.265L327.549 425.041L397.612 374.137L406.664 460.265Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M499.21 333.214L414.5 351.22L441.261 268.856L499.21 333.214Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M499.402 176.032L441.454 240.39L414.692 158.026L499.402 176.032Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M407.168 48.755L398.115 134.883L328.053 83.9795L407.168 48.755Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M198.758 196.56C187.838 192.36 177.518 190.26 167.798 190.26C158.198 190.26 150.698 192.3 145.298 196.38C139.898 200.46 137.198 206.1 137.198 213.3C137.198 222.06 141.758 228.84 150.878 233.64C154.958 235.68 159.398 237.6 164.198 239.4C169.118 241.08 174.038 243 178.958 245.16C183.878 247.32 188.378 249.78 192.458 252.54C196.538 255.3 199.838 259.14 202.358 264.06C204.878 268.86 206.138 275.04 206.138 282.6C206.138 290.04 204.038 296.4 199.838 301.68C195.638 306.96 190.538 310.56 184.538 312.48C178.658 314.28 171.758 315.18 163.838 315.18C149.078 315.18 136.478 311.52 126.038 304.2L126.938 302.76C130.898 305.88 135.998 308.46 142.238 310.5C148.598 312.42 155.078 313.38 161.678 313.38C171.398 313.38 179.678 311.16 186.518 306.72C193.478 302.16 196.958 295.5 196.958 286.74C196.958 277.14 192.398 269.64 183.278 264.24C179.198 261.84 174.698 259.62 169.778 257.58C164.978 255.54 160.118 253.44 155.198 251.28C150.278 249 145.778 246.48 141.698 243.72C132.578 237.72 128.018 229.2 128.018 218.16C128.018 209.4 130.958 202.32 136.838 196.92C142.718 191.4 151.538 188.64 163.298 188.64C175.178 188.64 187.238 190.68 199.478 194.76L198.758 196.56ZM296.614 189V190.8H239.914V244.8H292.474V246.6H239.914V313.2H300.574V315H224.974V189H296.614ZM387.945 315H319.545V189H334.485V313.2H387.945V315Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.9c3b62c53ac8fa369031cde01b152a7a.svg";
export { ForwardRef as ReactComponent };